import React from 'react';
import { useTranslation } from '@sunbit-dev/translations';
import { ReturnToCartProps } from './models';

// TODO refactor web-ui-lib Popup component to purchase-common lib
import { newPopup as Popup } from '@sunbit-dev/web-ui-lib';
import * as styles from './styles';
import styled from 'styled-components';

export const ReturnToCartPopup = styled(({ onConfirm, onClose, noLightBox, className }: ReturnToCartProps) => {
  const { t } = useTranslation('components', { keyPrefix: 'return_to_cart_popup' });

  return (
    <Popup
      className={className}
      {...{
        grayButtonAction: onConfirm,
        blueButtonAction: onClose,
        grayButtonText: t('confirm_button'),
        blueButtonText: t('close_button'),
        noLightBox,
        dataTestId: 'cancellation-popup'
      }}
    >
      <h2 className="title-text">{t('title')}</h2>
      <p className="description-text">{t('description')}</p>
    </Popup>
  );
})`
  ${styles.ReturnToCart}
`;
